var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 10L38 10L38 36L12 36L12 10Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "metodo-de-pago"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    id: "Ellipse-3",
    fill: "#0D9C7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10L38 10L38 36L12 36L12 10Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x38_9",
    transform: "translate(13.969727 10.405273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2909 18.5826L12.2909 16.219C12.2909 14.9584 13.3152 13.9736 14.5364 13.9736L20.3667 13.9736L20.3667 11.3736C20.3667 10.3887 19.5788 9.60083 18.5939 9.60083L1.77273 9.60083C0.787879 9.60083 0 10.3887 0 11.3736L0 23.4675C0 24.4523 0.787879 25.2402 1.77273 25.2402L18.6333 25.2402C19.6182 25.2402 20.4061 24.4523 20.4061 23.4675L20.4061 20.8675L14.5758 20.8675C13.3152 20.8281 12.2909 19.8433 12.2909 18.5826L12.2909 18.5826Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2333 14.722L14.5757 14.722C13.7485 14.722 13.1182 15.3917 13.1182 16.1796L13.1182 18.5433C13.1182 19.3705 13.7879 20.0008 14.5757 20.0008L21.2727 20.0008C21.706 20.0008 22.0606 19.6463 22.0606 19.213L22.0606 15.4705C22.0212 15.0766 21.706 14.722 21.2333 14.722L21.2333 14.722ZM16.2303 18.7008C15.5212 18.7008 14.9303 18.1099 14.9303 17.4008C14.9303 16.6917 15.5212 16.1008 16.2303 16.1008C16.9394 16.1008 17.5303 16.6917 17.5303 17.4008C17.4909 18.1099 16.9394 18.7008 16.2303 18.7008L16.2303 18.7008Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0546 0.619048L11.6606 0.303896C11.0303 -0.168831 10.1637 -0.0900433 9.65154 0.54026L3.07275 8.81299L5.43639 8.81299L12.0546 0.619048Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70608 8.81296L14.0637 2.19477L12.803 1.17053L6.65759 8.81296L8.70608 8.81296Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.003 8.81301L18.7909 7.78876C19.2636 7.15846 19.1848 6.29179 18.5545 5.77967L14.7727 2.74634L9.92725 8.81301L18.003 8.81301Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIcon);
export default __webpack_public_path__ + "static/media/paymentsIcon.c348ebe878057071ec7317c33d5f1b0a.svg";
export { ForwardRef as ReactComponent };